var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return !_vm.isResinous()
    ? _c("div", [
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-lg-12 mb-2" }, [
            _c(
              "h4",
              {
                staticClass:
                  "font-weight-bold primary-heading text-lowercase patcraft-text-underline",
                attrs: {
                  "data-text": _vm.coordinatingTitle
                    ? _vm.coordinatingTitle.slice(0, 3)
                    : ""
                }
              },
              [
                _vm._v(
                  "\n        " + _vm._s(_vm.coordinatingTitle) + "\n      "
                )
              ]
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-lg-12" }, [
            _c("div", { staticClass: "row" }, [
              _c(
                "div",
                {
                  staticClass:
                    "product-display-control-coordinating-products col-md-2 mt-3 mt-xl-0 px-3"
                },
                [
                  _c(
                    "button",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value:
                            _vm.selectedCordinatingProducts &&
                            _vm.selectedCordinatingProducts.flag,
                          expression:
                            "selectedCordinatingProducts && selectedCordinatingProducts.flag"
                        }
                      ],
                      staticClass: "btn dropdown-toggle px-1",
                      class: _vm.priceTag ? "disabled" : "",
                      attrs: {
                        type: "button",
                        id: "dropdownPriceLabel",
                        "data-toggle": "dropdown",
                        "aria-haspopup": "true",
                        "aria-expanded": "false",
                        disabled: _vm.priceTag
                      }
                    },
                    [
                      _c(
                        "p",
                        { staticClass: "pl-2 m-0 mr-auto text-truncate" },
                        [
                          _vm._v(
                            "\n              " +
                              _vm._s(
                                _vm.$resourceString[
                                  "product.Details.Price.Label"
                                ]
                              ) +
                              "\n            "
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c("span", {
                        staticClass:
                          "png-icon png-icon-icons-glyph--g-chevron-down"
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _vm.coordinatingProductsFilters &&
                  _vm.coordinatingProductsFilters.Prices
                    ? _c(
                        "div",
                        {
                          staticClass: "dropdown-menu",
                          attrs: { "aria-labelledby": "dropdownPriceLabel" }
                        },
                        _vm._l(_vm.coordinatingProductsFilters.Prices, function(
                          price
                        ) {
                          return _c(
                            "div",
                            {
                              key: price,
                              staticClass: "custom-control custom-checkbox"
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "dropdown-item dropdown-item-collection pt-0 text-truncate custom-control custom-checkbox"
                                },
                                [
                                  _c("input", {
                                    staticClass: "custom-control-input",
                                    attrs: { id: price, type: "checkbox" },
                                    domProps: {
                                      value: price,
                                      checked:
                                        _vm.coordinatingProductsFiltersSelected &&
                                        _vm.coordinatingProductsFiltersSelected
                                          .price &&
                                        _vm.coordinatingProductsFiltersSelected.price.some(
                                          function(i) {
                                            return i === price
                                          }
                                        )
                                    },
                                    on: {
                                      click: function($event) {
                                        return _vm.clickCoordinatingFilter({
                                          type: "",
                                          category: price,
                                          inputFilter: "price"
                                        })
                                      }
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "label",
                                    {
                                      staticClass: "custom-control-label pt-2",
                                      attrs: { for: price }
                                    },
                                    [
                                      _vm._v(
                                        "\n                  " +
                                          _vm._s(price) +
                                          "\n                "
                                      )
                                    ]
                                  )
                                ]
                              )
                            ]
                          )
                        }),
                        0
                      )
                    : _vm._e()
                ]
              )
            ])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "mt-4 d-flex flex-wrap" }, [
          _c(
            "div",
            { staticClass: "similar-products-initial-image d-none d-lg-block" },
            [
              _c("img", {
                staticClass: "img-fluid",
                attrs: {
                  src:
                    _vm.selectedProduct && _vm.selectedColor
                      ? _vm.$helpers.getColorThumbnailImageUrl(
                          _vm.selectedProduct.sellingStyleNumber,
                          _vm.selectedColor.colorNumber
                        )
                      : _vm.defaultImage,
                  alt: "img"
                },
                on: { error: _vm.handleImageError }
              }),
              _vm._v(" "),
              _c("div", { staticClass: "mt-3 description text-uppercase" }, [
                _c("strong", [
                  _vm._v(
                    "\n          " +
                      _vm._s(
                        _vm.$resourceString["product.Details.ThisStyle.Label"]
                      ) +
                      ": "
                  ),
                  _c("br"),
                  _vm._v(
                    "\n          " +
                      _vm._s(_vm.selectedColor && _vm.selectedColor.colorName) +
                      "\n          " +
                      _vm._s(
                        _vm.selectedColor && _vm.selectedColor.colorNumber
                      ) +
                      "\n          "
                  ),
                  _c("br"),
                  _vm._v(
                    "\n          " +
                      _vm._s(
                        _vm.productData && _vm.productData.sellingStyleName
                      ) +
                      "\n          " +
                      _vm._s(
                        _vm.selectedProduct &&
                          _vm.selectedProduct.sellingStyleNumber
                      ) +
                      "\n        "
                  )
                ])
              ])
            ]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "similar-products-carsole" }, [
            !_vm.coordinatingProducts ||
            _vm.coordinatingProducts.length === 0 ||
            _vm.fetchingCoordinatingProducts
              ? _c("div", { staticClass: "text-center" }, [
                  _vm.coordinatingProducts &&
                  _vm.coordinatingProducts.length === 0 &&
                  !_vm.fetchingCoordinatingProducts
                    ? _c("p", { staticClass: "mt-5" }, [
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              _vm.$resourceString[
                                "producT.CoordinatingProductsMessage"
                              ]
                            ) +
                            "\n        "
                        )
                      ])
                    : _c(
                        "p",
                        { staticClass: "mt-5" },
                        [
                          _vm.fetchingCoordinatingProducts
                            ? _c("pc-load-more", {
                                attrs: { "load-more": _vm.onLoadMore }
                              })
                            : _vm._e()
                        ],
                        1
                      )
                ])
              : _c(
                  "div",
                  { staticClass: "pc-product-coordinating-carousel" },
                  [
                    _vm.coordinatingProducts &&
                    _vm.coordinatingProducts.length > 0
                      ? _c(
                          "VueSlickCarousel",
                          _vm._b(
                            {
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "nextArrow",
                                    fn: function() {
                                      return [
                                        _c(
                                          "button",
                                          {
                                            staticClass: "custom-arrow-next",
                                            attrs: { type: "button" }
                                          },
                                          [
                                            _c("span", {
                                              staticClass:
                                                "png-icon png-icon-icons-glyph--k-chevron-right"
                                            })
                                          ]
                                        )
                                      ]
                                    },
                                    proxy: true
                                  },
                                  {
                                    key: "prevArrow",
                                    fn: function() {
                                      return [
                                        _c(
                                          "button",
                                          {
                                            staticClass: "custom-arrow-prev",
                                            attrs: { type: "button" }
                                          },
                                          [
                                            _c("span", {
                                              staticClass:
                                                "png-icon png-icon-icons-glyph--k-chevron-left"
                                            })
                                          ]
                                        )
                                      ]
                                    },
                                    proxy: true
                                  }
                                ],
                                null,
                                false,
                                2598201106
                              )
                            },
                            "VueSlickCarousel",
                            _vm.settings,
                            false
                          ),
                          [
                            _vm._v(" "),
                            _vm._v(" "),
                            _vm._l(_vm.coordinatingProducts, function(
                              listProducts
                            ) {
                              return _c(
                                "div",
                                {
                                  key: listProducts.ColorNumber,
                                  staticClass: "carsole-img-cpd"
                                },
                                [
                                  _c(
                                    "a",
                                    {
                                      staticClass: "cart-item-model-no",
                                      attrs: {
                                        href: _vm.$helpers.getProductDetailUrl(
                                          listProducts.StyleNameURL,
                                          listProducts.SellingStyleNumber,
                                          listProducts.ColorNumber
                                        )
                                      }
                                    },
                                    [
                                      _c("img", {
                                        staticClass: "img-fluid",
                                        attrs: {
                                          src:
                                            listProducts.ImagePath ||
                                            _vm.defaultImage,
                                          alt: "img"
                                        },
                                        on: { error: _vm.handleImageError }
                                      })
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "mt-3 description text-uppercase"
                                    },
                                    [
                                      _c("strong", [
                                        _c("u", [
                                          _vm._v(
                                            "\n                  " +
                                              _vm._s(
                                                listProducts.ColorName || "N/A"
                                              ) +
                                              "\n                  " +
                                              _vm._s(
                                                listProducts.ColorNumber ||
                                                  "N/A"
                                              ) +
                                              "\n                "
                                          )
                                        ])
                                      ]),
                                      _vm._v(" "),
                                      _c("div", [
                                        _vm._v(
                                          _vm._s(
                                            listProducts.Collection || "N/A"
                                          )
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _c(
                                        "a",
                                        {
                                          class: _vm.OrderSampleEnabled
                                            ? "text-muted pointer-none"
                                            : "",
                                          attrs: {
                                            href: "javascript:void(0)",
                                            id: "add-to-cart"
                                          },
                                          on: {
                                            click: function($event) {
                                              $event.preventDefault()
                                              _vm.OrderSampleEnabled
                                                ? ""
                                                : _vm.addItemToCart(
                                                    listProducts
                                                  )
                                            }
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "\n                " +
                                              _vm._s(
                                                _vm.$resourceString[
                                                  "product.Details.AddToBasket.Label"
                                                ]
                                              ) +
                                              "\n              "
                                          )
                                        ]
                                      )
                                    ]
                                  )
                                ]
                              )
                            })
                          ],
                          2
                        )
                      : _vm._e()
                  ],
                  1
                )
          ])
        ])
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }